const binding = { modules: {}, dataActions: {} };

    (binding.modules['exchange'] = {
        c: () => require('partner/themes/exchange/exchange.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'exchange',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'exchange.theme.settings.json',
        md: 'src/themes/exchange'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };